document.addEventListener('DOMContentLoaded', function() {
  const hamburger = document.querySelector('.hamburger-icon');
  const menu = document.querySelector('.science-menu');
  const overlay = document.querySelector('.mobile-menu-overlay');
  const closeBtn = document.querySelector('.menu-close');

  hamburger.addEventListener('click', function() {
    menu.classList.add('active');
    overlay.style.display = 'block';
  });

  closeBtn.addEventListener('click', function() {
    menu.classList.remove('active');
    overlay.style.display = 'none';
  });

  overlay.addEventListener('click', function() {
    menu.classList.remove('active');
    overlay.style.display = 'none';
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Add 'active' class on load if 'show' class is present
  document.querySelectorAll(".accordion-collapse.show").forEach((collapse) => {
    collapse.previousElementSibling
      .querySelector(".accordion-button")
      .classList.add("active");
  });

  // Add event listeners for collapse events
  document.querySelectorAll(".accordion-collapse").forEach((collapse) => {
    collapse.addEventListener("shown.bs.collapse", function () {
      this.previousElementSibling
        .querySelector(".accordion-button")
        .classList.add("active");
    });

    collapse.addEventListener("hidden.bs.collapse", function () {
      this.previousElementSibling
        .querySelector(".accordion-button")
        .classList.remove("active");
    });
  });
});



jQuery(document).ready(function () {

  if (jQuery(window).width() > 1023) {
    var body = jQuery("body").outerWidth();
    var contain = jQuery(".article-section .container").innerWidth();
    var less = body - contain;
    var total = less / 2;
    setTimeout(function() {
        jQuery(".science-banner-slider .owl-dots").css("margin-left", total);
    }, 100);
    
  }

});


$(document).ready(function () {
if ($(window).width() > 1023) {
  var body = $("body").outerWidth();
  var contain = $(".article-section .container").innerWidth();
  var less = body - contain;
  var total = less / 2;
      $(".science-banner-slider .item .item-wrap").css("margin-left", total);
  
}

    $('.result-wrapper').owlCarousel({
      loop:false,
      margin:20,
      nav:false,
      autoHeight: true,
      touchDrag: false,
      mouseDrag: false,
      responsive:{
          0:{
              items:1.1,
              margin:10,
              touchDrag: true,
              mouseDrag: true,
              loop:true,
          },
          600:{
              items:2.1,
              margin:10,
              touchDrag: true,
              mouseDrag: true,
              loop:true,
          },
          1037:{
              items:4
          }
      }
  })

if (jQuery(window).width() < 1199) {
  
  // When play button is clicked
  $('.play-btn a').click(function() {
    // Get parent result-item container
    const $resultItem = $(this).closest('.result-item');
    
    // Find elements within this result item
    const $thumbnail = $resultItem.find('.video-thumbnail');
    const video = $resultItem.find('.result-video')[0]; // Get DOM element

    // Hide thumbnail and play video
    $thumbnail.hide();
    video.play();
    
    // Optional: Show video controls when playing
    video.controls = true;
  });

  // Optional: Pause video and show thumbnail when video ends
  $('.result-video').on('ended', function() {
    const $resultItem = $(this).closest('.result-item');
    $resultItem.find('.video-thumbnail').show();
    this.controls = false;
  });
  
}
  

  $(".science-banner-slider").owlCarousel({
    loop: true,
    margin: 10,
    dots: true,
    nav: false,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplayHoverPause: true,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });

  $(".see-more").click(function (event) {
    event.preventDefault(); // Prevents the default anchor tag behavior
    $(".product-content").addClass("expand"); // Adds the "expand" class
    $(this).remove(); // Removes the "see-more" anchor tag
  });

  // faq accordion divide in two column

  // Divide the accordion items into two boxes (containers)
  var $accordionItems = $(".faq-section .accordion-item");
  var halfway = Math.ceil($accordionItems.length / 2);

  // Create two new containers
  var $box1 = $('<div class="accordion-box" id="box1"></div>');
  var $box2 = $('<div class="accordion-box" id="box2"></div>');

  // Append the first half of the accordion items to box1
  $accordionItems.slice(0, halfway).appendTo($box1);

  // Append the second half of the accordion items to box2
  $accordionItems.slice(halfway).appendTo($box2);

  // Add the boxes to the accordion container
  $("#accordionExample").html($box1).append($box2);

  if ($(window).width() > 1023) {
    var body = $("body").outerWidth();
    var contain = $(".app-left-image-section .container").innerWidth();
    var less = body - contain;
    var total = less / 2;
    $(".app-feature-section .container-fluid").css("margin-left", total);
  }

  $(".latest-blog-slider").owlCarousel({
    loop: true,
    margin: 14,
    autoHeight: false,
    nav: true,
    navText: [
      "<img src='https://cdn.shopify.com/s/files/1/0723/6232/8288/files/Line_26_1.png'>",
      "<img src='https://cdn.shopify.com/s/files/1/0723/6232/8288/files/Line_26_1.png'>",
    ],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1200: {
        items: 3,
      },
      
    },
  });


  
  $(".app-feature-slider").owlCarousel({
    loop: true,
    margin: 20,
    autoHeight: false,
    nav: true,
    navText: [
      "<img src='https://cdn.shopify.com/s/files/1/0723/6232/8288/files/Line_26_1.png'>",
      "<img src='https://cdn.shopify.com/s/files/1/0723/6232/8288/files/Line_26_1.png'>",
    ],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1037: {
        items: 3.4,
      },
    },
  });

  $(".second-slider").owlCarousel({
    loop: true,
    margin: 20,
    nav: true,
    center: true,
    navText: [
      "<img src='https://cdn.shopify.com/s/files/1/0723/6232/8288/files/Line_26.png'>",
      "<img src='https://cdn.shopify.com/s/files/1/0723/6232/8288/files/Line_26.png'>",
    ],
    responsive: {
      0: {
        margin: 10,
        nav: false,
        center: false,
        items: 1.2,
      },
      767: {
        items: 1.5,
      },
      1000: {
        items: 2,
      },
    },
    onInitialized: addActiveClass,
    onChanged: addActiveClass,
  });

  function addActiveClass(event) {
    // Remove any existing 'before-center' classes
    $(".second-slider .owl-item").removeClass("before-center");

    // Get the index of the center item
    var centerIndex = event.item.index;

    // Calculate the index of the item before the center item
    var beforeCenterIndex = centerIndex - 1;

    // Handle wrapping in the carousel (loop mode)
    if (beforeCenterIndex < 0) {
      beforeCenterIndex = event.item.count - 1;
    }

    // Add the class to the item before the center item
    $(".second-slider .owl-item")
      .eq(beforeCenterIndex)
      .addClass("before-center");
  }

  var owl = $(".experience-slider");
  owl.owlCarousel({
    items: 3,
    margin: 25,
    loop: true,
    nav: true,
    navText: [
      '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none"> <path d="M21.1738 5.17773C21.588 5.17773 21.9238 5.51352 21.9238 5.92773C21.9238 6.34195 21.588 6.67773 21.1738 6.67773L21.1738 5.17773ZM1.12083 6.45809C0.827934 6.1652 0.827934 5.69032 1.12083 5.39743L5.89379 0.624453C6.18668 0.331559 6.66156 0.331558 6.95445 0.624451C7.24735 0.917344 7.24735 1.39222 6.95445 1.68511L2.71182 5.92776L6.95446 10.1704C7.24736 10.4633 7.24736 10.9382 6.95446 11.2311C6.66157 11.5239 6.1867 11.5239 5.89381 11.2311L1.12083 6.45809ZM21.1738 6.67773L1.65116 6.67776L1.65116 5.17776L21.1738 5.17773L21.1738 6.67773Z" fill="#AD4FDF"/> </svg>',
      '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="12" viewBox="0 0 22 12" fill="none"> <path d="M0.826173 6.50391C0.411959 6.50391 0.0761723 6.16812 0.0761719 5.75391C0.0761714 5.33969 0.411957 5.00391 0.826171 5.00391L0.826173 6.50391ZM20.8792 5.22355C21.1721 5.51645 21.1721 5.99132 20.8792 6.28421L16.1062 11.0572C15.8133 11.3501 15.3384 11.3501 15.0455 11.0572C14.7527 10.7643 14.7527 10.2894 15.0455 9.99653L19.2882 5.75388L15.0455 1.51125C14.7526 1.21836 14.7526 0.743482 15.0455 0.450589C15.3384 0.157695 15.8133 0.157695 16.1062 0.450588L20.8792 5.22355ZM0.826171 5.00391L20.3488 5.00388L20.3488 6.50388L0.826173 6.50391L0.826171 5.00391Z" fill="#AD4FDF"/> </svg>',
    ],
    responsive: {
      0: {
        items: 1.1,
        nav: false,
        margin: 10,
      },
      768: {
        items: 2,
      },
      900: {
        items: 3,
        margin: 25,
      },
    },
  });

  var owll = $(".features-slider-mobile");
  owll.owlCarousel({
    items: 1.2,
    margin: 15,
    loop: true,
    nav: false,
  });

  AOS.init({ duration: 800 });

  const $image = $(".third-section .full-image img");
  function updateBorderRadius() {
    const maxBorderRadius = $(window).width() > 1200 ? 450 : 100;
    const offset = $(window).width() > 1200 ? 650 : 650;
    const section = $(".third-section");
    const sectionTop = section.offset().top + offset;
    const sectionHeight = section.outerHeight() - 2 * offset;
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();
    if (
      viewportBottom > sectionTop &&
      viewportTop < sectionTop + sectionHeight
    ) {
      const visibleTop = Math.max(viewportTop, sectionTop);
      const visibleBottom = Math.min(
        viewportBottom,
        sectionTop + sectionHeight
      );
      const visibleHeight = visibleBottom - visibleTop;
      const visibilityPercentage = visibleHeight / sectionHeight;
      const newBorderRadius = Math.min(
        maxBorderRadius,
        visibilityPercentage * maxBorderRadius
      );
      $image.css("border-radius", `${newBorderRadius}px`);
    } else {
      $image.css("border-radius", "0");
    }
  }
  updateBorderRadius();
  $(window).on("scroll resize", updateBorderRadius);



  
});


document.querySelectorAll('.des-title').forEach(title => {
    title.addEventListener('click', function() {
        const text = this.closest('.product__description').querySelector('.des-text');
        this.classList.toggle('active');
        text.classList.toggle('active');
    });
});




document.getElementById('ProductSubmitButton-{{ section_id }}').addEventListener('click', async function(e) {
  e.preventDefault();
  
  // Get the form and variant selector
  const form = this.closest('form');
  const variantInput = form.querySelector('[name="id"]');
  
  if (!variantInput || !variantInput.value) {
    console.error('No variant selected');
    return;
  }

  this.classList.add('loading');
  
  try {
    // Add to cart using Shopify's AJAX API
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: variantInput.value,
          quantity: form.querySelector('[name="quantity"]')?.value || 1
        }]
      })
    });

    // Redirect to checkout
    window.location.href = '/checkout/';
    
  } catch (error) {
    console.error('Error:', error);
    alert('Error adding product to cart. Please try again.');
  } finally {
    this.classList.remove('loading');
  }
});

   